export default __webpack_public_path__ + "static/media/Scholar's Mantle of the Exiled.8ccd14df.jpg";